import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import ChevronRight from '@mui/icons-material/ChevronRight'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import capitalizeFirstWord from 'services/helper/capitalizeFirstWord'

export default function PendingReportsList({
  reportID,
  reportName,
  muiIcon,
  totalAmount,
  reportType,
  startDate,
  endDate,
}) {
  const location = useLocation()
  const navigate = useNavigate()
  const handleClick = () => {
    navigate(`/app/claim/reports/${reportID}`, {
      state: { currentLocation: location },
    })
  }
  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: { md: 'row', xs: 'column' },
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2,
        borderBottom: 1,
        borderColor: 'gray-line.main',
        width: '100%',
        cursor: 'pointer',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: { md: '70%', xs: '100%' },
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'alternate.light',
            borderRadius: '50%',
            aspectRatio: 1,
            width: 50,
            height: 50,
          }}
        >
          <Icon sx={{ fontSize: 25, color: 'alternate.main' }}>{muiIcon}</Icon>
        </Box>
        <Box>
          <Typography
            variant="body1"
            color="dark-text.main"
            sx={{ whiteSpace: 'wrap', textOverflow: 'ellipsis' }}
          >
            {capitalizeFirstWord(reportName)}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              noWrap
              component="span"
              variant="body2"
              color="light-gray-text.main"
              textTransform="capitalize"
            >
              {reportType}
            </Typography>
            <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle_rounded</Icon>
            <Typography
              noWrap
              component="span"
              variant="body2"
              color="light-gray-text.main"
              textTransform="capitalize"
            >
              {startDate} - {endDate}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: { md: '30%', xs: '100%' },
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <StatusBar status="PENDING" />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" color="dark-text.main" fontWeight="bold" noWrap>
            {`RM ${parseFloat(totalAmount).toFixed(2)}`}
          </Typography>
          <ChevronRight color="light-gray-text" />
        </Box>
      </Box>
    </Box>
  )
}
